import { DefaultsApi, useAPIQuery } from "melco-shared-logic";

export const useRoles = () => {
  return useAPIQuery(DefaultsApi, ["roles"], async (api) => {
    const result = await api.defaultsGetRoles({});

    return result.list ?? [];
  });
};
